import {
  LandingPageOptions,
  SetupBaseRequestInfo,
  IAMUserState,
  SetupListNavInfoByDepartment,
  JsonSchema,
  EvaluatedResults,
  RowDataReducerAction,
  RowData,
  ReadRecordRequest,
} from "../../../../types";
import { getUpdatedNewEntryRowData } from "../customRowDataHelpers";
import { getRowDataList } from "../dataHelpers";
import { setEvaluationResultsIfNeeded } from "../evaluationHelpers";
import { getStoreLevelAccountName } from "../sharedHelpers";
import { getDepartmentIdByStore } from "../storeHelpers";
import { getNewRow } from "../tableHelpers";

export async function fetchRowDataListWithUpdatedOptions({
  landingPageOptions,
  setupBaseRequestInfo,
  iamUserState,
  setupListNavInfoByDepartment,
  headerLabel,
  schema,
  evaluatedResults,
  setEvaluatedResults,
  dispatch,
  setTableTitleInfo,
}: {
  landingPageOptions: LandingPageOptions;
  setupBaseRequestInfo: SetupBaseRequestInfo;
  iamUserState: IAMUserState;
  setupListNavInfoByDepartment: SetupListNavInfoByDepartment;
  headerLabel: string;
  schema: JsonSchema;
  evaluatedResults: EvaluatedResults;
  setEvaluatedResults: React.Dispatch<React.SetStateAction<EvaluatedResults>>;
  dispatch: React.Dispatch<RowDataReducerAction>;
  setTableTitleInfo?: (title: string) => void;
}): Promise<RowData[]> {
  const { store, groupId, department, setup } = landingPageOptions;

  const updatedSetupBaseRequestInfo: ReadRecordRequest = {
    ...setupBaseRequestInfo,
    storeId: store.value,
    functionalArea: department.value,
    functionalUnitName: setup.value,
    accountName: getStoreLevelAccountName(
      store.value,
      department.value,
      iamUserState.extendedAccountInfo,
      setupListNavInfoByDepartment,
    ),
    departmentId: getDepartmentIdByStore({
      store: store.value,
      department: department.value,
      extendedAccountInfo: iamUserState.extendedAccountInfo,
      setupListNavInfoByDepartment,
    }),
    groupId: groupId.value,
  };

  const updatedRowDataList = await getRowDataList(updatedSetupBaseRequestInfo);

  const newRowData = await getUpdatedNewEntryRowData({
    schema,
    rowData: getNewRow(schema),
    store: store.value,
    department: department.value,
    extendedAccountInfo: iamUserState.extendedAccountInfo,
    accountName: updatedSetupBaseRequestInfo.accountName,
    setupBaseRequestInfo: updatedSetupBaseRequestInfo,
    setupListNavInfoByDepartment,
  });

  setTableTitleInfo?.(`${headerLabel} (${updatedRowDataList.length})`);

  await setEvaluationResultsIfNeeded({
    setupBaseRequestInfo: updatedSetupBaseRequestInfo,
    evaluatedResults,
    setEvaluatedResults,
    iamUserState,
    setupListNavInfoByDepartment,
  });

  dispatch({
    type: "UPDATE_ROW_DATA_REDUCER_STATE",
    payload: {
      rowDataList: updatedRowDataList,
      rowData: newRowData,
      rowDataErrors: {},
      resetState: {
        rowDataList: updatedRowDataList,
        newEntryRowData: newRowData,
      },
    },
  });

  return updatedRowDataList;
}
